<template>
    <section v-if="getContacts">
        <div id="container-contacts-form" class="container d-flex">
            <div class="text-align-start formHeader">
                <img src="/imgs/icons/adv-logo-sm.png" alt="Advance Management Logo"
                    style="max-width: 2em; margin-right: .5em">
                <span style="vertical-align: middle; font-weight: 600">Contatos</span>
            </div>
            <div id="div-title">
                <i class="fa fa-address-book fa-2x" aria-hidden="true" style="color: rgb(28,134,154)"></i>
                <h2 id="container-title">Cadastro de Contatos</h2>
            </div>
            <form action="" id="contacts-form">
                <div class="row form-row">
                    <div class="custom-input-group">
                        <label for="contactName">Nome</label>
                        <input class="form-control" name="contactName" type="text" v-model="contact.name"
                            placeholder="Insira o nome do contato" required>
                    </div>
                    <div class="custom-input-group">
                        <label for="contactPhone">Telefone</label>
                        <vue-tel-input id="phone-input" defaultCountry="" mode="international" v-model="contact.phone"
                            :inputOptions="options">
                        </vue-tel-input>
                    </div>
                </div>

                <div class="row form-row">
                    <div class="custom-input-group mt-2">
                        <label for="unique_key">Funcional</label>
                        <select class="form-control mr-3 ml-3" name="id-cpf" id="id-cpf" v-model="idCpf"
                            style="flex: 1">
                            <option value="id">ID</option>
                            <option value="cpf">CPF</option>
                            <option value="cnpj">CNPJ</option>
                        </select>
                        <input class="form-control" name="contactKey" type="text" v-model="contact.unique_key"
                            :placeholder="maskPlaceholder" @input="applyMask" style="flex: 4">
                    </div>
                    <div class="custom-input-group">
                        <label for="type">Tipo</label>
                        <v-select :options="optionsDependentes" v-model="contact.number_contact" name="type">
                        </v-select>
                    </div>
                </div>

                <div class="row form-row">
                    <div class="custom-input-group" style="flex: 2">
                        <label for="company">Empresa</label>
                        <v-select :options="optionsEmpresas" v-model="contact.company_name" name="company">
                        </v-select>
                    </div>
                    <div class="custom-input-group" style="flex: 2">
                        <label for="filter">Grupo</label>
                        <input class="form-control" name="filter" type="text" v-model="contact.filter">
                    </div>
                </div>

                <div class="row form-row">
                    <div class="custom-input-group" v-if="subCompanyShow()">
                        <label for="subcompany">Sub-empresa</label>
                        <v-select :options="optionsSubEmpresasFilter()" v-model="contact.corporation"
                            name="subcompany"></v-select>
                    </div>
                    <div class="custom-input-group program">
                        <span><b>Programa: </b>{{ getProgram() }}</span>
                        <span><b>Número: </b>{{ getNumber() }}</span>
                    </div>
                </div>

                <div v-if="saving">
                    <p id="saving"><strong><i class="fas fa-spinner fa-pulse"></i> Salvando contato...</strong></p>
                </div>

                <div v-else>
                    <button type="submit" class="btn btn-success" id="btn-save" form="chamadoForm"
                        @click.prevent="saveContact()"><i class="fas fa-check"></i>
                        Salvar
                    </button>
                    <button type="submit" class="btn btn-danger" id="btn-cancel" form="chamadoForm"
                        @click.prevent="resetContact()"><i class="fas fa-window-close fa-fw"></i>
                        Cancelar
                    </button>

                </div>

            </form>
        </div>
    </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import vSelect from 'vue-select';

export default {
    name: "Contacts",
    data() {
        return {
            subCompanyId: [4, 5, 6],
            optionsDependentes: ['Dependente', 'Funcionário'],
            optionsEmpresas: [],
            optionsSubEmpresas: [],
            contact: {
                name: "",
                phone: "",
                unique_key: '',
                number_contact: '',
                company_name: '',
                corporation: '',
                filter: ''
            },
            idCpf: "cpf",
            options: {
                placeholder: 'Insira o telefone',
                required: true
            },
            saving: false
        }
    },
    async created() {
        const res = await axios.get('/api/companies');
        const subRes = await axios.get('/api/subcompanies');

        this.optionsEmpresas = res.data;
        this.optionsSubEmpresas = subRes.data;
    },
    components: {
        ...mapGetters(['getContacts']), vSelect
    },
    methods: {
        applyMask() {
            if (this.idCpf === 'cpf') {
                let value = this.contact.unique_key.replace(/\D/g, '').slice(0, 11);
                this.contact.unique_key = value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
            } else if (this.idCpf === 'cnpj') {
                let value = this.contact.unique_key.replace(/\D/g, '').slice(0, 14);
                this.contact.unique_key = value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
            }
        },
        subCompanyShow() {
            try {
                const found = this.optionsEmpresas.filter(el => el.label == this.contact.company_name.label)

                if (this.subCompanyId.includes(parseInt(found[0].code))) {
                    return true;
                }

                return false;

            } catch (e) {

                return false;

            }
        },
        optionsSubEmpresasFilter() {

            if (this.contact.company_name == null) {
                this.company_name = {}
                this.company_name.label = null
            }

            const filter = this.optionsSubEmpresas.filter(el => ((el.Empresa == this.contact.company_name) || el.Empresa == this.contact.company_name.label));
            return filter;
        },
        getProgram() {
            try {
                if (this.contact.company_name.programa) return this.contact.company_name.programa;

                return (found) ? found[0].programa : '';

            } catch (e) {
                return '';
            }
        },
        getNumber() {
            try {
                if (this.contact.company_name.numero) return this.contact.company_name.numero;

            } catch (e) {
                return '';
            }
        },
        checkForm: function () {
            if (this.contact.name == '') {
                Swal.fire({
                    html: 'O campo "Nome" não foi preenchido!',
                    type: "warning",
                    showCloseButton: true,
                    confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
                });
                return false
            }
            if (this.contact.phone == '') {
                Swal.fire({
                    html: 'O campo "Telefone" não foi preenchido!',
                    type: "warning",
                    showCloseButton: true,
                    confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
                });

                return false;
            } else {
                return true;
            }
        },
        saveContact: function () {
            if (this.checkForm()) {
                this.saving = true;
                this.contact.company_name = (this.contact.company_name && this.contact.company_name.label) ? this.contact.company_name.label : this.contact.company_name;
                this.contact.corporation = (this.contact.corporation && this.contact.corporation.label) ? this.contact.corporation.label : this.contact.corporation;

                axios.post("dialer/saveContact", this.contact).then(data => {
                    if (data.data.passed == false) {
                        let str = '';
                        Object.keys(data.data.errors).forEach(key => {
                            str += data.data.errors[key];
                        });

                        console.log('str', str);
                        Swal.fire({
                            type: "warning",
                            title: "Não foi possível inserir o cliente a base",
                            text: str
                        }).then(comfirm => {
                            this.saving = false
                        })
                        return;
                    }
                    Swal.fire({
                        type: "success",
                        title: "Feito!",
                        text: "Contato salvo com sucesso!"
                    }).then(comfirm => {
                        this.saving = false
                        this.contact.name = ""
                        this.contact.phone = ""
                        this.contact.corporation = ""
                        this.contact.unique_key = ""
                        this.contact.company_name = ""
                        this.contact.number_contact = ""
                        this.setMessage();
                    });

                })
            }
        },
        resetContact: function () {
            Swal.fire({
                title: 'Deseja descartar as informações?',
                text: 'Você perderá as alterações não salvas!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: 'rgb(28,134,154)',
                confirmButtonText: 'Sim, descartar',
                cancelButtonText: 'Voltar ao formulário'
            }).then((result) => {
                if (result.value) {
                    this.contact.name = ""
                    this.contact.phone = ""
                    this.contact.name = ""
                    this.contact.phone = ""
                    this.contact.corporation = ""
                    this.contact.unique_key = ""
                    this.contact.company_name = ""
                    this.contact.number_contact = ""
                }
            })
        }
    },
    computed: {
        ...mapGetters([
            'getContacts',
        ]),
        ...mapActions(['setMessage']),
        maskPlaceholder() {
            if (this.idCpf === 'cpf') {
                return 'XXX.XXX.XXX-XX';
            } else if (this.idCpf === 'cnpj') {
                return 'XX.XXX.XXX/XXXX-XX';
            } else {
                return 'Id do contato';
            }
        }
    },
    watch: {
        idCpf() {
            this.contact.unique_key = "";
        },
        "contact.status": function () {
            this.contact.corporation = '',
                this.contact.filter = ''
        }
    }
}
</script>

<style scoped>
.formHeader {
    background-color: rgb(28, 134, 154);
    border-top: 3px solid #f38630;
    color: white;
    padding: 0.2em;
    display: flex;
    border-radius: 20px 20px 0px 0px
}

.form-row {
    display: flex;
    flex-direction: row;
    margin: 10px;
}

.custom-input-group {
    align-self: center;
    flex: 1;
    position: relative;
    display: flex;
    align-items: stretch;
    width: 100%;
}

.program {
    flex-direction: column;
}

#container-contacts-form {
    margin: 3em;
    width: 65vw;
    border: solid 2px lightgray;
    border-radius: 25px;
    text-align: center;
    flex-direction: column;
    margin: 10px;
    padding: 0
}

#saving {
    color: rgb(28, 134, 154);
    font-size: 16px;
    text-align: center
}

#div-title {
    display: flex;
    flex-direction: column;
    margin: 20px;
}

#contacts-form {
    display: flex;
    flex-direction: column;
    text-align: center;
}

#buttonGroup {
    display: flex;
    justify-content: center;
}

#btn-save {
    border: solid 2px #008000;
    border-radius: 20px;
    background-color: #008000;
    color: white;
    transition: 0.5s
}

#btn-save:hover {
    color: #008000;
    background-color: white;

}

#btn-cancel {
    border: solid 2px #b30000;
    border-radius: 20px;
    background-color: #b30000;
    color: white;
    transition: 0.5s
}

#btn-cancel:hover {
    color: #b30000;
    background-color: white;

}

section {
    display: flex;
    justify-content: center;
}

h2 {
    color: rgb(28, 134, 154)
}

label {
    margin: 10px;
    font-size: 16px;
    font-weight: 500;
}

select {
    align-self: center;
}

input {
    /* width: 40px; */
    align-self: center;
}

button {
    width: 120px;
    margin: 20px;
    border-radius: 10px !important
}

.center {
    display: flex;
    justify-content: center;
    align-items: center;
}

.box-company-data {
    border: solid 1px;
    border-radius: 0.25em;
    width: 50%;
    text-align: center;
    margin-bottom: 1em;
    padding-top: 1em;
}

.append-data {
    padding: 3em;
    background-color: white;
    border: ridge 2px;
    border-radius: 1.5em;
    margin-left: 1em;
    margin-right: 1em;
}

.v-select {
    width: 100%;
    align-self: center;
}
</style>
